//Third party libraries

import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';

//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';

//Assets and miscellaneous
import type { DashboardType } from '../../../types/Analytics';
import { Widget } from '../constants';
//Custom components
import WidgetLayout from '../WidgetLayout';

const TotalProjectsWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchTotalProjectsWidgetData = useDashboardData({
    dashboard,
    widget: Widget.TOTAL_PROJECTS,
  });
  const totalProjectsWidgetData = fetchTotalProjectsWidgetData?.data?.data;

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.TOTAL_PROJECTS} actionsBtnLocation='top-2 right-0'>
      <NumericMetricWidget
        title='Total Projects'
        value={totalProjectsWidgetData ? totalProjectsWidgetData : 0}
        // toolTip="Cumulative number of all projects in any phase of Rebuild"
        // icon={
        //   <BuildingOfficeIcon className="w-14 sm:w-12 h-14 sm:h-12 text-blue-500" />
        // }
      />
    </WidgetLayout>
  );
};

export default TotalProjectsWidget;
